import React from 'react';

import { Colors } from 'theme/colors';
import { NakedIcon } from 'theme/icons';
import { Container } from 'theme/layout';
import { Light, Medium } from 'theme/text';

import { Avatar, AvatarContainer, CircleAction, NavSection } from './styles';

const ROSE_IMAGE = '/images/rose.jpg';
const BORDER_BOTTOM = `1px solid ${Colors.gallery}`;

const DEFAULT_CLOSE_RIGHT = '18px';
const MOBILE_CLOSE_RIGHT = '8px';

const DEFAULT_BACK_LEFT = '17px';
const MOBILE_BACK_LEFT = '7px';

const DEFAULT_REFRESH_RIGHT = 65;
const MOBILE_REFRESH_RIGHT = 95;

const ICON_SIZE = 12;

/**
 * Renders the chat header.
 *
 * @param props - Chat header props.
 */
export function BaseChatHeader(props: BaseChatHeaderProps) {
  const { backIsVisible, onClose, onPrevious, onRestart, refreshIsVisible, accentColor } = props;

  return (
    <NavSection borderTopColor={accentColor} borderBottom={BORDER_BOTTOM}>
      {backIsVisible && (
        <CircleAction
          onPress={onPrevious}
          borderColor={Colors.white}
          left={[MOBILE_BACK_LEFT, DEFAULT_BACK_LEFT]}
        >
          <NakedIcon size={ICON_SIZE} color={Colors.black} name="arrow-left" />
        </CircleAction>
      )}
      <Container
        display="flex"
        flex={1}
        justifyContent={'center'}
        alignItems="center"
        flexDirection="row"
        px={15}
      >
        <AvatarContainer>
          <Avatar src={ROSE_IMAGE} />
        </AvatarContainer>
        <Medium color={Colors.black}>
          Rose <Light>from Naked</Light>
        </Medium>
      </Container>
      <CircleAction
        onPress={onClose}
        borderColor={Colors.white}
        right={[MOBILE_CLOSE_RIGHT, DEFAULT_CLOSE_RIGHT]}
      >
        <NakedIcon size={ICON_SIZE} color={Colors.black} name="close" />
      </CircleAction>
      {refreshIsVisible && (
        <CircleAction
          onPress={onRestart}
          backgroundColor={Colors.white}
          borderColor={Colors.alto}
          right={[DEFAULT_REFRESH_RIGHT, MOBILE_REFRESH_RIGHT]}
        >
          <NakedIcon size={ICON_SIZE} color={Colors.black} name="restart" />
        </CircleAction>
      )}
    </NavSection>
  );
}
/**
 * Renders the chat header with logic to determine whether back should be visible.
 *
 * @param props - Chat header props.
 */
export function ChatHeader(props: ChatHeaderProps) {
  const { isNextIsLoading, isFirstState, ...dumbChatHeaderProps } = props;
  const backIsVisible = !isFirstState && !isNextIsLoading;

  return <BaseChatHeader backIsVisible={backIsVisible} {...dumbChatHeaderProps} />;
}
/* Type definition for ChatHeader */
interface ChatHeaderProps extends Props {
  /** Indicates the whether next state is loading */
  isNextIsLoading: boolean;
  /** Indicates the visibility state of the previous button */
  isFirstState: boolean;

  accentColor?: string;
}

/* Type definition for DumbChatHeader*/
interface BaseChatHeaderProps extends Props {
  /** Indicates the visibility state of the back button */
  backIsVisible: boolean;
  accentColor?: string;
}

/** Common Props for chat header implementations */
interface Props {
  /** Emits an `onClose` event when the close button is pressed. */
  onClose?(): void;
  /** Emits an `onPrevious` event when the previous button is pressed. */
  onPrevious?(): void;
  /** Emits an `onRestart` event when the restart chat button is pressed. */
  onRestart?(): void;
  /** Indicates the visibility state of the refresh button */
  refreshIsVisible: boolean;
}
